import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CompanyMinimalFragment,
  TemplateFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { TemplateIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type TemplateUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: TemplateFragment;
};

export function isTemplateUpdatedActivity(
  q: ActivityFragment
): q is TemplateUpdatedActivity {
  return q.key === "template.updated";
}

interface TemplateUpdatedActivityProps {
  activity: TemplateUpdatedActivity;
}

export const TemplateUpdatedActivity: React.FC<TemplateUpdatedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="templateUpdatedActivity"
        visual={<TemplateIcon className="w-10 h-10 text-accent-500" />}
      >
        <Text fontSize="sm">
          {t("activity.labels.templateUpdated", {
            template: (
              <Link to={`/templates/${activity.trackable.slug}/edit`}>
                {activity.trackable.title}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
